import c from 'classnames';

import { Icon, Typography } from '@repo/ui';

import styles from './TinyAIHeader.module.css';

interface TinyAIHeaderProps {
  isExpanded: boolean;
  onToggleExpand: () => void;
}

export const TinyAIHeader = ({
  isExpanded,
  onToggleExpand,
}: TinyAIHeaderProps) => {
  return (
    <div className={styles.header}>
      <div className={styles.titleSection}>
        <Icon name='aiGradient' className={styles.icon} preserveColors />
        <div className={styles.titleWrapper}>
          <Typography variant='heading-xl' className={styles.gradientText}>
            TinyAI
          </Typography>
          <Typography variant='label' className={styles.betaTag}>
            Beta
          </Typography>
        </div>
      </div>
      <button
        className={c(styles.expandButton, 'hide-on-mobile')}
        onClick={onToggleExpand}
        aria-label={isExpanded ? 'Minimize' : 'Expand'}
      >
        <Icon name={isExpanded ? 'collapse' : 'expand'} size='s' />
      </button>
    </div>
  );
};
